<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				
			</template>
			<template #actions><el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button></template>
			<el-form-item label="枚举名称：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入枚举名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="枚举编号：">
					<el-input clearable v-model="formInline.code" size="small" placeholder="请输入枚举编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
			</lcsj-filter>
			<STable
				:columns="columnsData"
				:data="listData"
				:loading="loading"
				:row-key="'keyId'"
				lazy
				:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
				@handle-command="handleCommand"
				@load-children="loadChildren"
				@row-click="handleRowClick"
			>
				<template #handle>
					<el-table-column label="操作" width="200" fixed="right" align="center">
						<template #default="scope">
							<el-button
								v-if="scope.row.parentKeyId === ''"
								size="mini"
								icon="el-icon-plus"
								@click.stop="
									handleCommand({
										rowData: scope.row,
										command: '1'
									})
								"
							>
								新增
							</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetEnumConfigList } from "../../../api/enumApi.js";
import edit from "./edit";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "配置列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			lazy: true,
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				name: ""
			},
			listData: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "120",
					isKeep: true
				},
				{
					prop: "name",
					label: "枚举名称",
					isKeep: true,
					align: "center",
					width: "200"
				},
				{
					prop: "code",
					label: "枚举编号",
					align: "center",
					width: "200"
				},
				{
					prop: "description",
					label: "枚举信息描述",
					align: "left"
				},
				{
					prop: "seq",
					label: "排序",
					align: "center",
					width: "120"
				},
				{
					slot: "handle",
					isKeep: true,
					label: "操作"
				}
			],
			expandRowKeys: []
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.$nextTick(() => {
			this.getListData();
		});
	},
	activated() {
		this.doLayoutTable();
	},

	computed: {},
	methods: {
		// 对table重新布局
		doLayoutTable() {
			if (this.$refs.tableData && this.$refs.tableData.doLayout) {
				this.$refs.tableData.doLayout();
			}
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 顶部tab页面切换
		changePages(tab) {},

		// 搜索框值变化
		inputChange() {
			this.search();
		},

		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.addSubData(command.rowData);
					break;
				default:
					console.log(command);
			}
		},

		// 新增父表
		handleEdit() {
			let row = undefined;
			this.$refs.edit.editShow(row, 1);
		},

		// 新增子表
		addSubData(row) {
			if (row.parentKeyId === "") {
				this.$refs.edit.editShow(row, 2);
			}
		},

		// 加载子表
		loadChildren(row, treeNode, resolve) {
			this.getChildrenListData(row.keyId, resolve);
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row, 1);
		},

		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},

		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},

		// 获取列表
		getListData() {
			this.listData = [];
			this.loading = true;
			GetEnumConfigList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						let temp = res.data;
						temp.forEach((item) => {
							item.hasChildren = true;
						});
						this.listData = temp;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 获取子列表
		getChildrenListData(keyId, resolve) {
			let param = {
				pageIndex: 1,
				pageSize: 25,
				parentKeyId: keyId
			};
			GetEnumConfigList(param)
				.then((res) => {
					if (res.code == 1) {
						// this.listColumns[4].operation = false;
						let temp = res.data;
						resolve(temp);
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
